module.exports = __webpack_public_path__ + "img/twbglhc_icon.953149ff.png";